import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import AccountForm from '../../Account/AccountForm';

export default function AccountEditPage({
	get_account_endpoint,
	update_account_endpoint
}) {
	const { id } = useParams();
	const location = useLocation();

	// Access the state passed from the Link
	const isEditing = location.state ? location.state.isEditing : '';

	useEffect(
		() => {
			console.log('Received id:', id);
			console.log('Received isEditing:', isEditing);
		},
		[
			id,
			isEditing
		]
	);

	return (
		<div>
			<AccountForm
				id={id}
				isEditing={isEditing}
				get_account_endpoint={get_account_endpoint}
				update_account_endpoint={update_account_endpoint}
			/>
		</div>
	);
}

AccountEditPage.propTypes = {
	get_account_endpoint: PropTypes.string.isRequired,
	update_account_endpoint: PropTypes.string.isRequired
};
